import axios from "axios";
import { API_URL } from "./constants";
import authHeader from "./auth-header";

class ItemListService {
  addToItemList(data) {
    return axios.post(`${API_URL}items-list`, data, {
      headers: authHeader(),
    });
  }
  fetchItemList(data) {
    return axios.post(`${API_URL}items-list/fetch-list`, data, {
      headers: authHeader(),
    });
  }
  setSingleValue(data, id) {
    return axios.put(`${API_URL}items-list/update-single-value/${id}`, data, {
      headers: authHeader(),
    });
  }

  deleteFromList(id, permanent) {
    return axios.delete(`${API_URL}items-list/${id}/${permanent}`, {
      headers: authHeader(),
    });
  }

  groupUngroupBulkAction(data) {
    return axios.post(`${API_URL}items-list-bulk-actions/group-ungroup`, data, {
      headers: authHeader(),
    });
  }

  bulkUpdateIndividualField(data) {
    return axios.post(
      `${API_URL}items-list-bulk-actions/individual-field`,
      data,
      {
        headers: authHeader(),
      }
    );
  }

  getStatusStats() {
    return axios.get(`${API_URL}items-list/status-stats`, {
      headers: authHeader(),
    });
  }

  fetchPrintQueueData(data) {
    return axios.post(`${API_URL}items-list/query-data`, data, {
      headers: authHeader(),
    });
  }

  exportPrintQueueData(data) {
    return axios.post(`${API_URL}items-list/export-print-queue-data`, data, {
      headers: authHeader(),
    });
  }

  setSingleColumn(data) {
    return axios.post(`${API_URL}items-list/set-single-column`, data, {
      headers: authHeader(),
    });
  }

  updateSearchedItems(data) {
    return axios.post(`${API_URL}items-list/update-items-in-bulk`, data, {
      headers: authHeader(),
    });
  }
}

export default new ItemListService();
